/** This model represents an item in the ViewingControls menu for a given catalog member in the workbench. (This menu has "Remove", "Export", "Compare", ...).
 * See `lib/ReactViews/Workbench/Controls/ViewingControls.tsx` for more info and usage
 */
let ViewingControls;
(function (_ViewingControls) {
  function is(model) {
    return "viewingControls" in model;
  }
  _ViewingControls.is = is;
})(ViewingControls || (ViewingControls = {}));
export default ViewingControls;